export default __webpack_public_path__ + "static/media/section2_pc@2x.c548916b.png";